module.exports = __webpack_public_path__ + "img/invitation_gift2.f73e55da.png";